<template>
  <div class="d-flex align-center">
    <v-btn
      depressed
      :small="$vuetify.breakpoint.mdAndDown"
      :height="$vuetify.breakpoint.mdAndDown ? 40 : 60"
      @click="$router.go(-1)"
    >
      <v-icon large>
        mdi-chevron-left
      </v-icon>
    </v-btn>
    <v-breadcrumbs
      :items="items"
      divider=">"
      large
    >
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          activeClass="breadcrumb-active"
          :to="item"
          :disabled="item.disabled"
          @click="(!item.name && item.action) ? $emit('send-action', item.action) : null"
        >
          <v-subheader class="p-0">
            {{ setText(item) }}
          </v-subheader>
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>

export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    methods: {
        // This checks
        setText(breadcrumb) {
            return breadcrumb.noTranslate ? breadcrumb.text : this.$t(breadcrumb.text);
        },
    },
};
</script>
